/* global axios */
import ApiClient from './ApiClient';

// Company-owned Asaas account used by the Talkvia AI to look up charges.
// The API key is write-only: responses expose only `api_key_configured`.
class AsaasIntegrationAPI extends ApiClient {
  constructor() {
    super('integrations/asaas', { accountScoped: true });
  }

  save(data) {
    return axios.patch(this.url, { asaas: data });
  }

  validate(data) {
    return axios.post(`${this.url}/validate`, { asaas: data });
  }

  remove() {
    return axios.delete(this.url);
  }
}

export default new AsaasIntegrationAPI();
